import { createContext, forwardRef, PropsWithoutRef } from 'react';

import { AppClockService, GainsightService, LoggerService } from '@mews/framework';
import { CalendarService } from '@optimus-web/core';

export interface DistributorContextValue {
    loggerService: LoggerService;
    appClockService: AppClockService;
    getCalendarService: () => CalendarService;
    gainsightService: GainsightService;
}

export const DistributorContext = createContext<DistributorContextValue>(
    undefined as unknown as DistributorContextValue
);
DistributorContext.displayName = 'DistributorContext';

const { Provider, Consumer } = DistributorContext;

export const createDistributorContextProvider =
    (distributorContextValue: DistributorContextValue) =>
    ({ children }: { children: React.ReactNode }) => <Provider value={distributorContextValue}>{children}</Provider>;

export const withDistributorContext = <P,>(Component: React.ComponentType<P & DistributorContextValue>) =>
    forwardRef((props: PropsWithoutRef<P>, ref) => (
        <Consumer>
            {(distributorContextValue) => <Component {...(props as P)} {...distributorContextValue} ref={ref} />}
        </Consumer>
    ));
